var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8554 6.56639C18.1173 6.56533 17.4096 6.27516 16.8878 5.75953C16.3659 5.24389 16.0725 4.54488 16.0717 3.81584V0H3.63285C2.66935 0 1.74533 0.377999 1.06404 1.05085C0.382748 1.7237 0 2.6363 0 3.58785V25.2163C0.00143078 26.1669 0.384806 27.0781 1.06594 27.7498C1.74708 28.4215 2.67029 28.7988 3.63285 28.7988H18.5652C19.5278 28.7988 20.451 28.4215 21.1321 27.7498C21.8132 27.0781 22.1966 26.1669 22.198 25.2163V6.56639H18.8554Z",
    fill: "#FF3E4C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1983 6.56639H18.8557C18.1175 6.56533 17.4099 6.27516 16.8881 5.75953C16.3662 5.24389 16.0727 4.54488 16.072 3.81584V0L22.1983 6.56639Z",
    fill: "#FF3E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8322 22.7471H7.95179C6.75438 22.7471 5.78369 23.7057 5.78369 24.8883V29.8588C5.78369 31.0414 6.75438 32 7.95179 32H24.8322C26.0296 32 27.0003 31.0414 27.0003 29.8588V24.8883C27.0003 23.7057 26.0296 22.7471 24.8322 22.7471Z",
    fill: "#FF3E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4675 28.4492V29.4185H11.4509V28.4492H12.4675Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9944 28.6362H15.7858V29.4188H12.9036V28.6815L14.6667 26.187H12.9265V25.4097H15.775V26.147L13.9944 28.6362Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3707 25.4097V29.4188H16.3933V25.4097H17.3707Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0298 28.0122V29.4188H18.0483V25.4097H19.6332C20.1152 25.4097 20.4837 25.527 20.7362 25.7643C20.864 25.888 20.9639 26.037 21.0293 26.2016C21.0946 26.3661 21.124 26.5424 21.1155 26.719C21.1198 26.9521 21.0611 27.1822 20.9454 27.3856C20.8276 27.5844 20.6529 27.7445 20.4432 27.8456C20.1902 27.9631 19.9127 28.0202 19.6332 28.0122H19.0298ZM20.1206 26.719C20.1206 26.3679 19.9235 26.1901 19.5293 26.1856H19.0298V27.2283H19.5293C19.9235 27.2327 20.1206 27.0629 20.1206 26.719Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0973 20.335C10.6433 20.3343 10.2081 20.1558 9.88718 19.8386C9.56627 19.5214 9.38585 19.0915 9.3855 18.6431V16.9512H12.8104V18.6431C12.8101 19.0917 12.6295 19.5219 12.3083 19.8391C11.9871 20.1563 11.5515 20.3347 11.0973 20.335ZM10.2616 17.8165V18.6431C10.2616 18.8621 10.3496 19.0722 10.5063 19.2272C10.663 19.3821 10.8755 19.4694 11.0973 19.4697C11.3192 19.4694 11.5319 19.3822 11.6887 19.2272C11.8456 19.0723 11.9339 18.8622 11.9343 18.6431V17.8165H10.2616Z",
    fill: "#FF3E4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38412 16.9526H11.1013V15.2567H9.38412V16.9526Z",
    fill: "#FF3E4C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0973 15.2578H12.8145V13.5619H11.0973V15.2578Z",
    fill: "#FF3E4C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38412 13.5635H11.1013V11.8676H9.38412V13.5635Z",
    fill: "#FF3E4C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0973 11.8687H12.8145V10.1727H11.0973V11.8687Z",
    fill: "#FF3E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeZip);
export default __webpack_public_path__ + "static/media/Type=ZIP.cd23cbdadbdf024c82e27daaec141a73.svg";
export { ForwardRef as ReactComponent };